import * as Mui from "@mui/material";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import OperationTypes from "../../../types";
import FormInput from "../../common/FormInput";

interface Props {
  vehicles?: OperationTypes.DeliveryNotesInfo[];
}

const Vehicles = (props: Props) => {
  const t = useOperationTranslation();

  return (
    <>
      {props.vehicles?.map((vehicle: any, index: number) => (
        <Mui.Box key={`vehicles-box-${index}`} mb={2}>
          <Mui.Card key={`vehicles-card-${index}`}>
            <Mui.CardContent key={`vehicles-card-content-${index}`}>
              <Mui.Grid
                container
                key={`vehicles-grid-content-${index}`}
                columns={12}
                alignItems="center"
                spacing={2.5}
                rowGap={4}
              >
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="vin"
                    label={t("transferReason.details.tab3.vin")}
                    value={vehicle?.vin || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="plate"
                    label={t("transferReason.details.tab3.plate")}
                    value={vehicle?.licensePlate || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="brand"
                    label={t("transferReason.details.tab3.brand")}
                    value={vehicle?.brand || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="model"
                    label={t("transferReason.details.tab3.model")}
                    value={vehicle?.model || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="carSegment"
                    label={t("transferReason.details.tab3.carSegment")}
                    value={vehicle?.carSegment || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="carClass"
                    label={t("transferReason.details.tab3.carClass")}
                    value={vehicle?.carClass || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="acriss"
                    label={t("transferReason.details.tab3.acriss")}
                    value={vehicle?.acriss || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="customAcriss"
                    label={t("transferReason.details.tab3.customAcriss")}
                    value={vehicle?.customAcriss || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="carCompany"
                    label={t("transferReason.details.tab3.carCompany")}
                    value={vehicle?.carCompany || ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="departureKm"
                    label={t("transferReason.details.tab3.departureKm")}
                    value={
                      vehicle?.departureKm !== undefined
                        ? vehicle?.departureKm
                        : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="departureThermicFuel"
                    label={t("transferReason.details.tab3.departureFuelLevel")}
                    value={
                      vehicle?.departureThermicFuel !== undefined
                        ? `${vehicle?.departureThermicFuel}/8`
                        : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="departureElectricLevel"
                    label={t(
                      "transferReason.details.tab3.departureBatteryLevel"
                    )}
                    value={
                      vehicle?.departureElectricLevel !== undefined
                        ? `${vehicle?.departureElectricLevel}%`
                        : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="arrivalKm"
                    label={t("transferReason.details.tab3.arrivalKm")}
                    value={
                      vehicle?.arrivalKm !== undefined ? vehicle?.arrivalKm : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="arrivalThermicFuel"
                    label={t("transferReason.details.tab3.arrivalFuelLevel")}
                    value={
                      vehicle?.arrivalThermicFuel !== undefined
                        ? `${vehicle?.arrivalThermicFuel}/8`
                        : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>

                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="arrivalElectricLevel"
                    label={t("transferReason.details.tab3.arrivalBatteryLevel")}
                    value={
                      vehicle?.arrivalElectricLevel !== undefined
                        ? `${vehicle?.arrivalElectricLevel}%`
                        : ""
                    }
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
                <Mui.Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                  <FormInput
                    name="loadIndex"
                    label={t("transferReason.details.tab3.loadIndex")}
                    value={vehicle?.weight !== undefined ? vehicle?.weight : ""}
                    type="text"
                    disabled
                    fullWidth
                  />
                </Mui.Grid>
              </Mui.Grid>
            </Mui.CardContent>
          </Mui.Card>
        </Mui.Box>
      ))}
    </>
  );
};

export default Vehicles;
